/* ========================================================================
 * Vendor scripts (footer)
 *
 * The project will include all vendor files specified below
 * ======================================================================== */

import './vendor/bower/datepicker.js';
import './vendor/bower/slick.js';
import './vendor/masonry.pkgd.min.js';
import Mustache from './vendor/bower/mustache.js';
global.Mustache = Mustache;
